import { FormSection } from '@ksyos/design-system';
import { TextAreaFormGroup } from '../../processActivityFormGroupFields';

export function BariPreMedConsultPlanAppointmentEdit(): JSX.Element {
    return (
        <FormSection>
            <TextAreaFormGroup
                fieldKey="toelichting"
                label="Toelichting"
                placeholder="Typ je toelichting..."
            />
        </FormSection>
    );
}
